import FetchConfig from "./../client/fetcher.js"
import MobileDetect from 'mobile-detect';

const md = new MobileDetect(window.navigator.userAgent);

export default {
    playAudioFile: async function(filePath, withDelay = false)  {
        let sound = new Audio(FetchConfig.MainHostFiles+filePath+".mp3")
        sound.preload = 'auto';
        sound.playbackRate = 0.85;

        if (md.mobile() !== null) {
            await sound.play()
        } else {
            sound.addEventListener('loadeddata', () => {
                if (withDelay) {
                    setTimeout(() => {
                        sound.play().catch(error => {
                            console.error('Ошибка при попытке воспроизведения аудио:', error);
                        });
                    }, 700)
                } else {
                    sound.play().catch(error => {
                        console.error('Ошибка при попытке воспроизведения аудио:', error);
                    });
                }
            });
        }
    },
}